export type LegacyDetailProduct = {
  id: string
  productType: number
  productTypeName: string
  statistics: string
  category: string
  name: string
  cost: number
  price: number
  vendor: string
  runtime: number | null
  minPhotos: number | null
  maxPhotos: number | null
  dpi: number | null
  minLong: number | null
  minShort: number | null
  hidden: boolean
}

export const legacyDetailProductTypes = [
  { id: 1, name: '촬영' },
  { id: 2, name: '앨범' },
  { id: 3, name: '액자' },
  { id: 4, name: '기타상품' },
  { id: 5, name: '파일' },
  { id: 6, name: '메이크업' },
  { id: 7, name: '의상대여' },
]

const typeDefaults: Record<number, Pick<LegacyDetailProduct, 'runtime' | 'minPhotos' | 'maxPhotos' | 'dpi' | 'minLong' | 'minShort'>> = {
  1: { runtime: 60, minPhotos: null, maxPhotos: null, dpi: null, minLong: null, minShort: null },
  2: { runtime: null, minPhotos: 10, maxPhotos: 20, dpi: 300, minLong: 3600, minShort: 2400 },
  3: { runtime: null, minPhotos: 1, maxPhotos: 3, dpi: 300, minLong: 3000, minShort: 2000 },
  4: { runtime: 30, minPhotos: null, maxPhotos: null, dpi: null, minLong: null, minShort: null },
  5: { runtime: null, minPhotos: 20, maxPhotos: 50, dpi: 300, minLong: 3600, minShort: 2400 },
  6: { runtime: 50, minPhotos: null, maxPhotos: null, dpi: null, minLong: null, minShort: null },
  7: { runtime: 40, minPhotos: null, maxPhotos: null, dpi: null, minLong: null, minShort: null },
}

export const legacyDetailProducts: LegacyDetailProduct[] = Array.from({ length: 28 }, (_, index) => {
  const productType = (index % 7) + 1
  const productTypeName = legacyDetailProductTypes[productType - 1].name
  return {
    id: `detail-${String(index + 1).padStart(2, '0')}`,
    productType,
    productTypeName,
    statistics: `Mock 통계 ${(index % 4) + 1}`,
    category: `Mock 상품구분 ${(index % 5) + 1}`,
    name: `Mock 상세 상품 ${String(index + 1).padStart(2, '0')}`,
    cost: 18000 + index * 2400,
    price: 35000 + index * 4800,
    vendor: `Mock 제작업체 ${(index % 3) + 1}`,
    hidden: index >= 24,
    ...typeDefaults[productType],
  }
})

export const legacyDetailStatistics = ['Select an Option', 'Mock 통계 1', 'Mock 통계 2', 'Mock 통계 3', '직접입력']
export const legacyDetailCategories = ['- 필수선택 -', 'Mock 상품구분 1', 'Mock 상품구분 2', 'Mock 상품구분 3', '직접입력']
export const legacyDetailVendors = ['- 필수선택 -', 'Mock 제작업체 1', 'Mock 제작업체 2']
